import React from 'react';
import Settings from '../../Popups/WebRtc/Settings';
import Dialer from '../../Popups/WebRtc/Dialer';

function WebRtcApp() {
    return (
        <div className="app-container min-h-screen flex items-center justify-center bg-primarybg p-4">
            <div className="flex flex-col lg:flex-row gap-4 w-full max-w-6xl">
                <Settings />
                <Dialer />
            </div>
        </div>
    );
}

export default WebRtcApp;